// src/contexts/ReflectionContext.js
import React, { createContext, useContext, useState } from 'react';

const ReflectionContext = createContext();

export const ReflectionProvider = ({ children }) => {
  const [showReflection, setShowReflection] = useState(false);
  const [currentWorkflows, setCurrentWorkflows] = useState([]); // 当前打开的工作流列表
  
  const openReflection = (workflows = []) => {
    setCurrentWorkflows(workflows);
    setShowReflection(true);
  };
  
  const closeReflection = () => {
    setShowReflection(false);
    setCurrentWorkflows([]);
  };
  
  const value = {
    showReflection,
    currentWorkflows,
    openReflection,
    closeReflection
  };

  return (
    <ReflectionContext.Provider value={value}>
      {children}
    </ReflectionContext.Provider>
  );
};

export const useReflection = () => {
  const context = useContext(ReflectionContext);
  if (!context) {
    throw new Error('useReflection must be used within a ReflectionProvider');
  }
  return context;
};